export const columns = {
  name: {
    key: 'name',
    label: 'Name',
    isSortable: true,
  },
  organLastCall: {
    key: 'organLastCall',
    label: 'Last Call',
    isSortable: false,
  },
  thirtyDays: {
    key: 'thirtyDays',
    label: '30 Days',
    isSortable: false,
  },
  location: {
    key: 'location',
    label: 'Home Location + Current',
    isSortable: false,
  },
  match: {
    key: 'match',
    label: 'Match',
    isSortable: false,
    minWidthClassName: 'min-w-[117px]',
  },
  affiliation: {
    key: 'affiliation',
    label: 'Affiliation',
    isSortable: false,
  },
  reservationCondition: {
    key: 'reservationCondition',
    label: 'Reservation condition',
    isSortable: false,
  },
  reserve: {
    key: 'reserve',
    label: '',
    isSortable: false,
    minWidthClassName: 'min-w-[130px]',
  },
};

export const EMPLOYEE_SURGEON_COLUMNS = [
  columns.name,
  columns.organLastCall,
  columns.thirtyDays,
  columns.location,
  columns.match,
  columns.reservationCondition,
  columns.reserve,
];

export const CONTRACTOR_SURGEON_COLUMNS = [
  columns.name,
  columns.organLastCall,
  columns.thirtyDays,
  columns.location,
  columns.affiliation,
  columns.reservationCondition,
  columns.reserve,
];
